import { Megaphone, X } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

type RollingAnnouncementProps = {
  content: string
  visible: boolean
  onDismiss: () => void
  variant?: 'app' | 'public'
}

export function RollingAnnouncement({
  content,
  visible,
  onDismiss,
  variant = 'app',
}: RollingAnnouncementProps) {
  const { t } = useTranslation()

  if (!visible) return null

  return (
    <section
      className={cn(
        'border-border bg-muted/50 text-muted-foreground notice-marquee relative z-30 flex h-9 w-full items-center border-y text-sm',
        variant === 'public' && 'fixed inset-x-0 top-16 z-40'
      )}
      aria-label={t('Rolling announcement')}
    >
      <Megaphone className='text-primary mx-3 size-4 shrink-0' aria-hidden />
      <div className='min-w-0 flex-1 overflow-hidden'>
        <div className='animate-notice-marquee flex w-max items-center whitespace-nowrap will-change-transform'>
          <span className='pr-16'>{content}</span>
          <span className='pr-16' aria-hidden>
            {content}
          </span>
        </div>
      </div>
      <Button
        type='button'
        variant='ghost'
        size='icon'
        className='mx-1 size-7 shrink-0'
        onClick={onDismiss}
        title={t('Close')}
        aria-label={t('Close')}
      >
        <X className='size-4' />
      </Button>
    </section>
  )
}
